import React, { useState, useRef, useEffect } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import {
  getUserList,
  sendMeetingDetail,
  sendMeetingDetailUserMail,
} from "../../api/apiHandler";
import { useLocation, useParams } from "react-router-dom";
import queryString from "query-string";
export function EmailMeetingRecordsPopup({
  isOpen,
  setIsOpen,
  meetingId,
  setMeetingId,
}) {
  const [emails, setEmails] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [emailError, setEmailError] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [doctorsList, setDoctorssList] = useState([]);
  const inputRef = useRef(null);
  const location = useLocation();
  console.log(location, "paramsjaskd");
  const param = queryString.parse(window.location.search);
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchQuery.trim() === "") {
        setDoctorssList([]);
        return;
      }

      getUserList({
        page: 1,
        record_count: 10,
        search_text: searchQuery,
        roles: [2, 3],
      }).then((response) => {
        response = JSON.parse(response);
        if (response.code == process.env.REACT_APP_SUCCESS) {
          setDoctorssList(response.data.list);
        } else {
          setDoctorssList([]);
        }
      });
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchQuery]);

  const mailRecords = async (data) => {
    try {
      handleInactive();
      const params = { emails, meeting_id: meetingId };
      Swal.fire({
        title: "Please wait...",
        didOpen: () => {
          Swal.showLoading();
        },
        allowOutsideClick: false,
      });
      let response;
      const path = location?.pathname;
      const isPriestMeeting = param?.isPriestMeeting === "true";

      if (
        path === "/doctor/single-user-history" ||
        path === "/priest/single-user-history" ||
        (isPriestMeeting &&
          path !== "/patient-priest/meeting-status" &&
          path !== "/patient/meeting-status")
      ) {
        response = await sendMeetingDetailUserMail(params);
      } else {
        response = await sendMeetingDetail(params);
      }

      response = JSON.parse(response);
      if (response.code == process.env.REACT_APP_SUCCESS) {
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: response.message,
          toast: true,
          showConfirmButton: false,
          timer: 2000,
        });
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: response.message,
          toast: true,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    } catch (e) {
      console.error("Error Sending meeting records:", e);
    }
  };

  const handleInactive = () => {
    setIsOpen(false);
    setEmails([]);
    setInputValue("");
    setEmailError("");
    setMeetingId("");
  };

  const addEmail = () => {
    const newEmail = inputValue.trim();
    if (newEmail === "") return;

    if (!validateEmail(newEmail)) {
      setEmailError("Invalid email address");
      return;
    }

    if (emails.includes(newEmail)) {
      setEmailError("Email already added");
      return;
    }

    setEmails([...emails, newEmail]);
    setInputValue("");
    setEmailError("");
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  const removeEmail = (index) => {
    setEmails(emails.filter((_, i) => i !== index));
  };

  const validateEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email);
  };

  const handleKeyDown = (e) => {
    if (["Enter", ",", " "].includes(e.key)) {
      e.preventDefault();
      addEmail();
    } else if (
      e.key === "Backspace" &&
      inputValue === "" &&
      emails.length > 0
    ) {
      setEmails(emails.slice(0, -1));
    }
  };

  const selectEmail = (email) => {
    if (!emails.includes(email)) {
      setEmails([...emails, email]);
    }
    setSearchQuery("");
    setDoctorssList([]);
  };

  return (
    <>
      <Modal size="md" centered show={isOpen} onHide={handleInactive}>
        <Modal.Header className="border-0 pb-0 align-items-start" closeButton>
          <Modal.Title
            className="fw-bold"
            style={{ fontSize: 20, lineHeight: "20px" }}
          >
            Enter recipient emails to send the Meeting Record.
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="py-2">
            <label
              htmlFor=""
              className="form-label m-0 fw-bold text-muted"
              style={{ fontSize: 14 }}
            >
              Search{" "}
            </label>
            <div className="search-bar position-relative">
              <input
                className="form-control"
                type="text"
                placeholder="Search user email..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              {doctorsList.length > 0 && (
                <ul
                  className="dropdown-list border p-3 rounded list-unstyled mb-0 bg-white shadow position-absolute"
                  style={{
                    maxWidth: "max-content",
                    fontSize: 14,
                    zIndex: 999,
                    maxHeight: "200px",
                    overflowY: "auto",
                  }}
                >
                  {doctorsList.map((doctor, index) => (
                    <li
                      key={index}
                      className="py-2 border-bottom"
                      onClick={() => selectEmail(doctor.email)}
                    >
                      {doctor.email}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
          <div className="py-2">
            <label
              htmlFor=""
              className="form-label m-0 fw-bold text-muted"
              style={{ fontSize: 14 }}
            >
              Enter Email{" "}
            </label>
            <div className="iconWithText position-relative">
              <button
                style={{ right: 4, height: 40, width: 40, minWidth: "unset" }}
                className="position-absolute icn d-flex align-items-center justify-content-center commonBtn rounded-circle p-2"
                onClick={addEmail}
              >
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.793 7.4999H2.5C2.36739 7.4999 2.24021 7.55258 2.14645 7.64635C2.05268 7.74011 2 7.86729 2 7.9999C2 8.13251 2.05268 8.25968 2.14645 8.35345C2.24021 8.44722 2.36739 8.4999 2.5 8.4999H11.793L8.146 12.1459C8.05211 12.2398 7.99937 12.3671 7.99937 12.4999C7.99937 12.6327 8.05211 12.76 8.146 12.8539C8.23989 12.9478 8.36722 13.0005 8.5 13.0005C8.63278 13.0005 8.76011 12.9478 8.854 12.8539L13.354 8.3539C13.4006 8.30745 13.4375 8.25228 13.4627 8.19153C13.4879 8.13079 13.5009 8.06567 13.5009 7.9999C13.5009 7.93413 13.4879 7.86901 13.4627 7.80827C13.4375 7.74752 13.4006 7.69234 13.354 7.6459L8.854 3.1459C8.76011 3.05201 8.63278 2.99927 8.5 2.99927C8.36722 2.99927 8.23989 3.05201 8.146 3.1459C8.05211 3.23979 7.99937 3.36712 7.99937 3.4999C7.99937 3.63267 8.05211 3.76001 8.146 3.8539L11.793 7.4999Z"
                    fill="black"
                  />
                </svg>
              </button>
              <div
                className="email-input-container overflow-auto border p-2 rounded"
                onClick={() => inputRef.current.focus()}
                style={{
                  maxHeight: 100,
                  // scrollbarWidth: "none"
                }}
              >
                {emails.map((email, index) => (
                  <span key={index} className="email-tag">
                    {email}
                    <button
                      className="remove-btn"
                      onClick={() => removeEmail(index)}
                    >
                      ×
                    </button>
                  </span>
                ))}
                <input
                  ref={inputRef}
                  type="text"
                  placeholder="Enter email..."
                  value={inputValue}
                  onChange={(e) => {
                    setInputValue(e.target.value);
                    setEmailError(""); // Reset error when typing
                  }}
                  onKeyDown={handleKeyDown}
                  className={`border-0 outline-0 pe-5 ${
                    emailError ? "error-border" : ""
                  }`}
                />
              </div>
            </div>
            {emailError && <p className="error-text mt-1">{emailError}</p>}
          </div>

          <div className="d-flex justify-content-center mt-4">
            <Button
              className="px-4 commonBtn"
              onClick={mailRecords}
              disabled={emails.length === 0}
            >
              Send Records
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      {/* Styles */}
      <style>{`
        .email-input-container {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          min-height: 40px;
          cursor: text;
        }
        .email-tag {
          background: #e1ecf4;
          color: #0b57d0;
          padding: 5px 10px;
          border-radius: 15px;
          margin: 3px;
          display: flex;
          align-items: center;
        }
        .remove-btn {
          background: transparent;
          border: none;
          color: #0b57d0;
          margin-left: 5px;
          cursor: pointer;
        }
        input {
          border: none;
          outline: none;
          flex: 1;
          padding: 5px;
          // min-width: 100px;
        }
        .error-text {
          color: red;
          font-size: 12px;
        }
        .error-border {
          border-bottom: 2px solid red;
        }
      `}</style>
    </>
  );
}
